<script>
    export let fill = '#FFF'
</script>

<style>
    svg#team-info-text {
        position: absolute;
        width: 388.54px;
        height: 62.99px;
        top: 60px;
        left: 25px;
    }

    .cls-1 {
        font-size: 16px;
        font-family: AvenirNext-Regular, Avenir Next;
    }
    .cls-1,
    .cls-3 {
        fill: #fff;
    }
    .cls-2 {
        letter-spacing: -0.05em;
    }
    .cls-3 {
        fill-rule: evenodd;
    }
    .cls-4 {
        letter-spacing: -0.02em;
    }
    .cls-5 {
        letter-spacing: -0.06em;
    }
</style>

<svg id="team-info-text" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 388.54 62.99">
    <defs />
    <g id="Layer_2" data-name="Layer 2">
        <g id="Layer_1-2" data-name="Layer 1">
            <text class="cls-1" transform="translate(156.37 14.89)">
                <tspan class="cls-2">F</tspan>
                <tspan x="8.22" y="0">ootball</tspan>
            </text>
            <polygon class="cls-3" points="10.68 1.82 8.82 0 0 8.63 8.82 17.25 10.68 15.44 3.72 8.63 10.68 1.82" />
            <text class="cls-1" transform="translate(156.37 56.41)">
                RO
                <tspan class="cls-4" x="23.18" y="0">S</tspan>
                <tspan x="31.92" y="0">TER</tspan>
            </text>
            <text class="cls-1" transform="translate(301.15 56.41)">
                <tspan class="cls-4">S</tspan>
                <tspan class="cls-5" x="8.74" y="0">T</tspan>
                <tspan x="16.9" y="0">AFF</tspan>
            </text>
            <text class="cls-1" transform="translate(5.34 56.41)">TEAM INFO</text>
        </g>
    </g>
</svg>
